var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 55,
    viewBox: "0 0 48 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 25.1646V13.3397C48 11.1309 46.33 8.62589 44.2559 7.79087L29.2525 1.64945C25.8855 0.275706 22.0875 0.275706 18.7205 1.64945L3.71718 7.79087C1.67004 8.62589 0 11.1309 0 13.3397V25.1646C0 38.3364 9.56231 50.6731 22.6262 54.2825C23.5151 54.525 24.4848 54.525 25.3737 54.2825C38.4377 50.6731 48 38.3364 48 25.1646ZM26.0202 29.8784V36.9626C26.0202 38.067 25.1043 38.9828 23.9999 38.9828C22.8956 38.9828 21.9797 38.067 21.9797 36.9626V29.8784C19.2592 29.0165 17.266 26.4845 17.266 23.4946C17.266 19.7774 20.2828 16.7606 23.9999 16.7606C27.7171 16.7606 30.734 19.7774 30.734 23.4946C30.734 26.5114 28.7407 29.0165 26.0202 29.8784Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb4);
export default __webpack_public_path__ + "static/media/ab_4.e1a0eadb8c262c4c722ee487a9b4d971.svg";
export { ForwardRef as ReactComponent };